import { render } from "./CommandCenterKpiCard.vue?vue&type=template&id=06312472&scoped=true"
import script from "./CommandCenterKpiCard.vue?vue&type=script&lang=js"
export * from "./CommandCenterKpiCard.vue?vue&type=script&lang=js"

import "./CommandCenterKpiCard.vue?vue&type=style&index=0&id=06312472&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06312472"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QTooltip});
